import React from "react";
import { func } from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";
import Check from "pages/_components/Check";
import { actions as echeckActions } from "reducers/echecks";
import FilterTableHead from "../../components/FilterTableHead";

const ReceivedEcheckTitleColumns = ({ selectAll, allChecksAreChecked }) => {
    const dispatch = useDispatch();
    const { echeqFilters: filters } = useSelector((state) => state.echecks);

    const changeFilter = (filterName, filterDirecion) => {
        const requestFilters = {
            ...filters,
            orderColumName: filterName,
            orderDirection: filterDirecion,
            pageNumber: 1,
        };
        dispatch(echeckActions.setEcheqFilters(requestFilters));

        selectAll(false);
        // setSubmitting(true);
        dispatch(echeckActions.filterEcheqList(requestFilters));
    };

    return (
        <>
            <GridTable.Data>
                <Check
                    hideLabel
                    id="selectAll"
                    name="selectAll"
                    onChange={(e) => selectAll(e.target.checked)}
                    checked={allChecksAreChecked()}
                />
            </GridTable.Data>
            <GridTable.Data>
                <I18n component="span" id="echecks.number" />
            </GridTable.Data>
            <GridTable.Data alignX="center">
                <I18n component="span" id="echecks.character" />
            </GridTable.Data>
            <GridTable.Data alignX="center">
                <I18n component="span" id="echecks.emisor" />
            </GridTable.Data>
            <GridTable.Data alignX="center">
                <I18n component="span" id="echecks.table.document" />
            </GridTable.Data>
            <GridTable.Data alignX="center">
                <I18n component="span" id="echecks.currency" />
            </GridTable.Data>
            <GridTable.Data alignX="center">
                <I18n component="span" id="echecks.table.amount" />
            </GridTable.Data>
            <GridTable.Data alignX="center">
                <I18n component="span" id="echecks.table.datePayed" />
                <FilterTableHead
                    filterName="fecha_pago"
                    columnFilter={{
                        filterSelected: filters.orderColumName,
                        directionFilter: filters.orderDirection,
                    }}
                    changeFilter={changeFilter}
                />
            </GridTable.Data>
            <GridTable.Data alignX="center">
                <I18n component="span" id="echecks.status" />
            </GridTable.Data>
            <GridTable.Data />
        </>
    );
};

ReceivedEcheckTitleColumns.propTypes = {
    selectAll: func.isRequired,
    allChecksAreChecked: func.isRequired,
};

export default ReceivedEcheckTitleColumns;
